import templateUrl from "emun.order/recently-viewed/recently-viewed-orders-dropdown.htm";
import controller from "emun.order/recently-viewed/recently-viewed-orders-dropdown.controller";

export default {
  bindings: {
    buttonType: "@",
    dropdownClasses: "@",
    dropdownMenuClasses: "@",
    icon: "@",
    label: "@",
    orderRoute: "@",
    hideBadge: "<?",
    hideLabel: "<?",
    onSelected: "&"
  },
  transclude: {
    dropdownToggle: "?dropdownToggle",
    append: "?append"
  },
  controller,
  templateUrl($element, $attrs) {
    if ($attrs.templateUrl) return $attrs.templateUrl;
    return templateUrl;
  }
};
